export default __webpack_public_path__ + "ccd6f133bcb6c8318c4942e601ae7561.png";